const appConfig = {
  BASE_URL: "https://rieshim.app/",
};

export default appConfig;
